export default __webpack_public_path__ + "static/media/Epidemiologic.icon.55ae64bc.svg";